import React from "react";

import styles from "../../../features/management/db-list/detail/DatabaseDetail.module.scss";

type Props = {
  title: string;
  children: string | React.ReactNode;
  className?: string;
};

const DetailInfo: React.FC<Props> = ({ title, children, className }) => {
  return (
    <div className={styles["f-databaseDetail__info"]}>
      <span className={styles["f-databaseDetail__info-title"]}>{title}</span>
      <div
        className={`${styles["f-databaseDetail__info-content"]} ${
          className ? styles[className] : ""
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default DetailInfo;
